import { useState, useEffect } from 'react';

const useClockTime = () => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const s = time.getSeconds();
  const m = time.getMinutes();
  const h = time.getHours() % 12;

  return {
    time,
    secondDeg: s * 6,
    minuteDeg: m * 6 + s * 0.1,
    hourDeg: h * 30 + m * 0.5,
    hours24: time.getHours(),
    minutes: m,
    seconds: s,
  };
};

export default useClockTime;
